const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
    continueButton: '.button--continue',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const continueButton = document.querySelector(defaults.continueButton);
const htmlSelector = document.documentElement;



// Handle variant size
if ($('.pdp-upgrade-v2.has_size').length == 1) {
    $(".size_select li").not(".disabled").first().addClass("active_size");

    let size_first = $('.active_size').attr('value');

    $('.product-form__buttons.has_size button').attr('data-value', size_first)

    $('ul[name="id"] li:not(.disabled)').on('click', function (e) {
        $('ul[name="id"] li:not(.disabled)').removeClass('active_size');
        $('ul[name="id"] li:not(.disabled)').removeClass('choose_size');
        $(this).addClass('choose_size');

        let dataSize = $(this).attr('value');
        $(this).parents('body').find('.js-ajax-add-to-cart.has_size').attr('data-value', dataSize)
    })

}


for (let i = 0; i < addToCart.length; i++) {
    addToCart[i].addEventListener('click', function (event) {
        event.preventDefault();

        if ($(this).hasClass('has_size')){
            const formID1 = $(this).attr('data-value');
            addProductToCartSize(formID1);

        }else {
            const formID = this.parentNode.getAttribute('id');
            addProductToCart(formID);
            // console.log('Tesst click 1', formID)

        }
    });
}

/* Product bundles by Mageworx */
function hasProductAddons() {
  const mwProductAddons = document.querySelector('mw-product-addons');
  if (mwProductAddons && mwProductAddons.shadowRoot) {
    return mwProductAddons.shadowRoot.querySelector('.ProductAddons') !== null;
  }
  return false;
};
/* Product bundles by Mageworx */


function addProductToCartSize(formID1) {
    /* Product bundles by Mageworx */
    const isAddons = hasProductAddons();

    if (isAddons) {
        return;
    }
    /* Product bundles by Mageworx */

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: 'quantity=1&id=' + formID1,
        success: addToCartOk,
        error: addToCartFail,
    });
}



function addProductToCart(formID) {
   /* Product bundles by Mageworx */
    const isAddons = hasProductAddons();

    if (isAddons) {
        return;
    }
    /* Product bundles by Mageworx */
    
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID).serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });
    
}

function fetchCart(product = null) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
            onCartUpdate(cart, product);

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = 'Cart is empty';
                checkoutButton.classList.add('is-hidden');
            } else {
                renderCart(cart);
                checkoutButton.classList.remove('is-hidden');
            }

        },
    });
}

function changeItem(line, quantity = 0, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart, product = null) {
    const arrId = [];
    const arrProperties = [];
    const productJson = JSON.stringify(product);
    const arrPrd = JSON.parse(productJson);
    cart.items.forEach(function (item, index) {
        arrId.push(item.id);
        const propertiesItem = item.properties;
        if (propertiesItem && Object.keys(propertiesItem).length === 1 && Object.getPrototypeOf(propertiesItem) === Object.prototype) {
            arrProperties.push(JSON.stringify(item.properties));
        }
    });
    if (arrPrd) {
        if (arrId.includes(arrPrd.id)) {
            let quantity = 0;
            let line = 0;
            if (arrPrd.properties && arrProperties.includes(JSON.stringify(arrPrd.properties))) {
                let currentItemCheckNotPre = document.getElementById(arrPrd.id);
                if (typeof (currentItemCheckNotPre) !== 'undefined' && currentItemCheckNotPre !== null) {
                    // quantity = document.querySelector(arrPrd.id+' .ajax-cart-item__single').textContent;
                    line = parseInt(currentItemCheckNotPre.getAttribute('data-line'));
                    // changeItem(line,quantity);
                    changeItem(parseInt(line + 1), quantity);
                }
            } else {
                let currentItemCheckPre = document.getElementById('pre_order' + arrPrd.id);
                if (typeof (currentItemCheckPre) !== 'undefined' && currentItemCheckPre !== null) {
                    // quantity = document.querySelector('pre_order'+arrPrd.id+' .ajax-cart-item__single').textContent;
                    line = parseInt(currentItemCheckPre.getAttribute('data-line'));
                    // changeItem(line,quantity);
                    changeItem(parseInt(line + 1), quantity);
                }
            }
        }
    }
}

function addToCartOk(product) {
    // cartModalContent.innerHTML = product.title + ' was added to the cart!';
    // Handle category event remove_from_cart
    var categoryList = jQuery('.collection_title .breadcrumbs__link:first-child span').text().replace(/\s+/g, " ")

    var showList = [];

    var show = {
        id: product.key,
        categoryName: categoryList,
    };
    showList.push(show);
    showList = showList.concat(JSON.parse(localStorage.getItem('showList') || '[]'));
    // console.log(showList);


    localStorage.setItem("showList", JSON.stringify(showList));
    // console.log(test);

    console.log("Tesst data add", product)


    cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    if (Number(cartCounter.innerHTML) === 0) {
        cartCounter.classList.add("hidden");
        cartCounter.classList.remove("visible");
    } else {
        cartCounter.classList.add("visible");
        cartCounter.classList.remove("hidden");
        const viewCart = document.getElementById("view-my-cart");
        viewCart.innerHTML = "View my cart (" + Number(cartCounter.innerHTML) + ")";
    }
    // openAddModal();
    // openCartOverlay();
    openCartDrawer();
    fetchCart(product);

}

function removeProductFromCart() {
    cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
}

function renderCart(cart) {

    clearCartDrawer();

    cart.items.forEach(function (item, index) {

        //console.log(item.title);

        const productTitle = '<div class="ajax-cart-item__title">' + item.product_title + '</div>';
        let imgPrd = item.image;
        if (item.image == null) {
            imgPrd = '//cdn.shopify.com/s/files/1/0562/7648/4141/t/22/assets/placeholder-images-image_large.png?v=14594405247086941604';
        }
        const productImage = '<img class="ajax-cart-item__image" src="' + imgPrd + '" >';
        const productPrice = '<div class="ajax-cart-item__price">' + '$' + parseFloat(item.line_price / 100).toFixed(2) + '</div>';
        const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
        let styleVariant = '';
        if (item.variant_title == null) {
            styleVariant = 'style="display:none;"';
        }
        const productVariant = '<div class="ajax-variant-color" ' + styleVariant + '><span>' + item.options_with_values[0].name + ':</span>' + item.variant_title + '</div>';
        const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '" data-id="'+ item.id + '">x</div>';
        let preOrder = item.id;
        const propertiesItem = item.properties;


        if (propertiesItem && Object.keys(propertiesItem).length === 1 && Object.getPrototypeOf(propertiesItem) === Object.prototype) {
            preOrder = 'pre_order' + item.id;
            // Pre_note = '<div class="ajax-cart-preorder_note">' + 'Note: Pre-order success' + '</div>';
        }
        // else {
        //     Pre_note = "";
        // }

        const concatProductInfo = '<div id="' + preOrder + '" class="ajax-cart-item__single" data-id="' + preOrder + '" data-line="' + Number(index + 1) + '">' +
            '<div class="image">' + productImage + '</div>' +
            '<div class="content-minicart">' + productTitle + productVariant + productPrice + productQuantity + productRemove + '</div></div>';

        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

    });

    // document.querySelectorAll('.js-ajax-remove-from-cart')
    //     .forEach((element) => {
    //         element.addEventListener('click', function() {
    //             const lineID = this.parentNode.getAttribute('data-line');
    //             console.log('aa');
    //         });
    //     });

    // removeFromCart = document.querySelector(defaults.removeFromCart);

    // Fix action remove in minicart
    $(".js-ajax-remove-from-cart").on("click",function() {
        const line = this.closest(".ajax-cart-item__single").getAttribute('data-line');
        // console.log("Remove tesst", line)
        changeItem(line, 0);
    });

}

function openCartDrawer() {
    cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openAddModal() {
    cartModal.classList.add('is-open');
}

function closeAddModal() {
    cartModal.classList.remove('is-open');
}

// Click out side remove popup minicart
$(document).on('click', function (event) {
    if (!$(event.target).closest('.js-ajax-cart-drawer-trigger').length) {
        closeCartDrawer();
    }
})

// hover show minicart
if ($(window).width() > 1025) {
    $(".js-ajax-cart-drawer-trigger").mouseover(function () {
        cartDrawer.classList.add('is-open');
    });

    $(".js-ajax-cart-drawer").hover(
        function () {
            cartDrawer.classList.add('is-open');
        },
        function () {
            cartDrawer.classList.remove('is-open');
        }
    );
}


function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function () {
    closeAddModal();
    closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function () {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function () {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function (event) {
    event.preventDefault();
    //fetchCart();
    if (window.screen.width > 1024) {
        openCartDrawer();
        openCartOverlay();
    }
});
continueButton.addEventListener('click', function (event) {
    closeCartDrawer();
    closeCartOverlay();
});

document.addEventListener('DOMContentLoaded', function () {
    fetchCart();
});